/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SubmitPromoOrGiftCardCodeInput = {
  /** Promotion or gift card code */
  readonly code: string;
};

export type ApplyPromoCodeMutationVariables = Exact<{
  input: Types.SubmitPromoOrGiftCardCodeInput;
}>;

export type ApplyPromoCodeMutation = {
  readonly submitPromoOrGiftCardCode:
    | { readonly __typename: 'InvalidPromoCode'; readonly message: string; readonly status: number }
    | { readonly __typename: 'PromoCodeAlreadyApplied' }
    | { readonly __typename: 'SubmitGiftCardCodeSuccess' }
    | { readonly __typename: 'SubmitPromoCodeSuccessV2' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const ApplyPromoCodeDocument = gql`
  mutation applyPromoCode($input: SubmitPromoOrGiftCardCodeInput!) {
    submitPromoOrGiftCardCode(input: $input) {
      __typename
      ... on InvalidPromoCode {
        message
        status
      }
      ... on ValidationError {
        message
        status
        fieldErrors {
          field
          message
        }
      }
    }
  }
`;

export function useApplyPromoCodeMutation() {
  return Urql.useMutation<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>(
    ApplyPromoCodeDocument,
  );
}
